import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import appointmentApis from 'features/appointment/services/apis';
import { IResponseDataBody } from 'services/response';
import { IApiGetSummaryAppointmentByDate } from 'features/appointment/services/types/appointment';

const useGetDateRangeSummary = () => {
  const currentDate = dayjs();
  const startDate = currentDate.format('MM-DD-YYYY');
  const endDate = currentDate.add(21, 'day').format('MM-DD-YYYY');
  const [data, setData] = useState<IApiGetSummaryAppointmentByDate[]>([]);

  const mutate = async () => {
    try {
      const res: IResponseDataBody<IApiGetSummaryAppointmentByDate[]> =
        await appointmentApis.getSummaryAppointmentByDate({
          startDate,
          endDate,
        });
      if (res?.data?.data) {
        setData(res?.data?.data);
      }
    } catch (error) {
      setData([]);
    }
  };

  useEffect(() => {
    mutate();
  }, []);

  return [data, mutate] as const;
};

export default useGetDateRangeSummary;
